import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export enum ArtistAboutStatus {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export interface ArtistAbout {
  id: string;
  introduction: string;
  resume: string;
  facebookUrl: string;
  instagramUrl: string;
  twitterUrl: string;
  websiteUrl: string;
  status: ArtistAboutStatus;
  rejectReason: string;
  rejectReasonText: string;
  createTime: string;
  createUserId: string;
  updateTime: string;
  updateUserId: string;
  auditUserId: string;
  auditTime: string;
  nickName: string;
  name: string;
  userNumber: string;
}

export interface ArtistAboutListParams {
  currentPage: number;
  pageSize: number;
  id?: string;
  submitTime?: string;
  auditUserName?: string;
  suppId?: string;
  userName?: string;
  email?: string;
  status?: ArtistAboutStatus;
}

export const getArtistAboutList = async (params: ArtistAboutListParams) => {
  const resp = await axiosInstance.post<BaseResponse<TableList<ArtistAbout>>>(
    `${baseUrl}/about/queryPageList?currentPage=${params.currentPage}&pageSize=${params.pageSize}`,
    params
  );
  return resp.data;
};

export interface ArtistSubmitParams {
  id: string;
  introduction: string;
  resume: string;
  rejectReason?: string[];
  rejectReasonText?: string;
}

export const rejectArtistAbout = async (params: ArtistSubmitParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/about/submit/reject`,
    params
  );
  return resp.data;
};

export const publishArtistAbout = async (params: ArtistSubmitParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/about/submit/publish`,
    params
  );
  return resp.data;
};

export const getArtistAboutDetail = async (id: string) => {
  const resp = await axiosInstance.get<BaseResponse<ArtistAbout>>(
    `${baseUrl}/about/detail/${id}`
  );
  return resp.data;
};
